import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { CommonService } from '../../../shared/services/commom.service';
import { EncriptyUtilService } from '../../../shared/services/encripty-util.service';
import { GeraPedidoPrePagoService } from './gera-pedido-pre-pago.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { NotificationsService } from 'angular2-notifications';
import { HttpParams } from '@angular/common/http';
import { ModalPedidoGeradoComponent } from './modal-pedido-gerado/modal-pedido-gerado.component';
import { NbDialogService } from '@nebular/theme';
import { CentroCustoService } from '../../gestao-plano-viagem/plano-viagens/centro-custo/centro-custo.service';

@Component({
  selector: 'ngx-gera-pedido-pre-pago',
  templateUrl: './gera-pedido-pre-pago.component.html',
  styleUrls: ['./gera-pedido-pre-pago.component.scss']
})
export class GeraPedidoPrePagoComponent implements OnInit {

  public formGeraPedido = null;
  public razaoSocial = null;
  public produto = null;
  public balanceCardInfo = [];
  public listProdutos: any = null;
  public listCentroCusto: any = [];
  public limiteGlobal = null;
  public saldoGlobal = null;
  public isLimiteGlobal = false;
  public isSaldoGlobal = false;
  public customLogin = null;
  public tipoPagamento = null;
  public permitePix = 'S';

  constructor(
    private location: Location,
    private formBuilder: FormBuilder,
    private router: Router,
    private service: GeraPedidoPrePagoService,
    private encriptyService: EncriptyUtilService,
    private commomService: CommonService,
    private spinnerService: NgxSpinnerService,
    private notificationService: NotificationsService,
    private dialogService: NbDialogService,
    private centroCustoservice: CentroCustoService,
  ) {

  }

  ngOnInit() {

    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);
    document.title = this.customLogin.title;
    const idProduto = this.encriptyService.decriptyBySecretKey(localStorage.getItem('bway-product-id'));

    this.razaoSocial =
      this.encriptyService.decriptyBySecretKey(localStorage.getItem('bway-enterprise-name'));

    this.produto =
      this.encriptyService.decriptyBySecretKey(localStorage.getItem('bway-product-description'));

    if ((this.produto === 'PAGAMENTO') || (this.produto === 'ALIMENTACAO_BANDEIRADO') || (this.produto === 'REFEICAO_BANDEIRADO')
      || (this.produto === 'FLEXIVEL')) {

      this.service.buscaSaldoGlobal(null, (response) => {
        this.saldoGlobal = response.saldoAtual
      }, null)

      this.isSaldoGlobal = true;

      this.commomService.buscaProdutos().subscribe(response => {
        this.listProdutos = response
        this.permitePix = response[0].permitePagamentoPix;
        this.listProdutos.forEach(produto => {
          if (produto.produtoId == idProduto) {
            if (produto.produtoDescricao == 'PAGAMENTO') {
              produto['taxaDescricao'] = 'TARIFA_EMISSAO_PLATAFORMA_PAGAMENTOS'
              this.balanceCardInfo.push({
                'label': produto.produtoDescricao,
                'descricao': 'SALARIO',
                'saldoAtual': produto.saldoGlobalAtual,
                'custoImportacao': 0,
                'icon': 'fas fa-coins',
                'type': 'danger',
                'selected': false,
                'taxaDescricao': 'TARIFA_EMISSAO_PLATAFORMA_PAGAMENTOS'
              })

            } else if (produto.produtoDescricao == 'ALIMENTACAO_BANDEIRADO') {
              produto['taxaDescricao'] = 'TARIFA_EMISSAO_PLATAFORMA_PAGAMENTOS';
              this.balanceCardInfo.push({
                'label': 'ALIMENTAÇÃO',
                'descricao': 'ALIMENTACAO_BANDEIRADO',
                'saldoAtual': produto.saldoGlobalAtual,
                'custoImportacao': 0,
                'icon': 'fas fa-address-card',
                'type': 'danger',
                'selected': false,
                'taxaDescricao': 'TARIFA_DE_EMISSAO_DE_CARTAO_ALIMENTACAO',
              });
            } else if (produto.produtoDescricao == 'REFEICAO_BANDEIRADO') {
              produto['taxaDescricao'] = 'TARIFA_EMISSAO_PLATAFORMA_PAGAMENTOS';
              this.balanceCardInfo.push({
                'label': 'REFEIÇÃO',
                'descricao': 'REFEICAO_BANDEIRADO',
                'saldoAtual': produto.saldoGlobalAtual,
                'custoImportacao': 0,
                'icon': 'fas fa-id-card',
                'type': 'info',
                'selected': false,
                'taxaDescricao': 'TARIFA_DE_EMISSAO_DE_CARTAO_REFEICAO',
              });
            } else if (produto.produtoDescricao == 'FLEXIVEL') {
              //produto['taxaDescricao'] = 'TARIFA_EMISSAO_PLATAFORMA_PAGAMENTOS';
              this.balanceCardInfo.push({
                'label': 'FLEXÍVEL',
                'descricao': 'FLEXIVEL',
                'saldoAtual': produto.saldoGlobalAtual,
                'custoImportacao': 0,
                'icon': 'fas fa-money-check',
                'type': 'info',
                'selected': false,
                //'taxaDescricao': 'TARIFA_DE_EMISSAO_DE_CARTAO_ALIMENTACAO',
              });
            }
          }
        });
      });

    } else if (this.produto === 'ADIANTA') {
      this.service.buscaLimiteGlobal(null, (response) => {
        this.limiteGlobal = response.limiteAtual
      }, null);

      this.isLimiteGlobal = true;
      this.commomService.buscaProdutos().subscribe(response => {
        this.listProdutos = response
        this.permitePix = response[0].permitePagamentoPix;
        this.listProdutos.forEach(produto => {
          if (produto.produtoDescricao === 'ADIANTA') {
            produto['taxaDescricao'] = 'TARIFA_EMISSAO_USUARIO_CONVENIO_BANDEIRADO'
            this.balanceCardInfo.push({
              'label': produto.produtoDescricao,
              'descricao': produto.produtoDescricao,
              'saldoAtual': produto.limiteGlobalAtual,
              'custoImportacao': 0,
              'icon': 'far fa-money-bill-alt',
              'type': 'primary',
              'selected': false,
              'taxaDescricao': 'TARIFA_EMISSAO_USUARIO_CONVENIO_BANDEIRADO'

            })
          }
        });
      });

    } else if (this.produto === 'VIAGEM') {

      this.commomService.buscaProdutos().subscribe(response => {
        this.listProdutos = response
        this.permitePix = response[0].permitePagamentoPix;
      });

      this.isLimiteGlobal = false;
      this.isSaldoGlobal = false;

    }

    this.formGeraPedido = this.formBuilder.group({
      valorPix: [''],
      valorBoleto: [''],
      formaPagamento: ['BOLETO'],
      razaoSocial: [null],
      centroCusto:[null]
    });

    this.formGeraPedido.controls['razaoSocial'].setValue(this.razaoSocial);

    this.buscarCentrosCusto();
  }

  solicitaPedido(data) {

    if (data.formaPagamento === "PIX" && (data.valorPix == '' || parseFloat(data.valorPix) == 0) || data.formaPagamento === "BOLETO" && (data.valorBoleto == '' || parseFloat(data.valorBoleto) == 0)) {
      this.notificationService.warn("Atenção!", "Valor obrigatório.");
      return;
    }

    let payload = {
      formaPagamento: data.formaPagamento,
      valorTotal: data.formaPagamento === "PIX" ? data.valorPix : data.valorBoleto,
      centroDeCustoId: data.centroCusto ? data.centroCusto : null
    }

    this.spinnerService.show();
    this.service.inserePedido(payload,
      (response) => {
        this.service.buscaSaldoGlobal(null, (response) => {
          this.saldoGlobal = response.saldoAtual
        }, null)
        this.spinnerService.hide();
        this.limparForm();
        this.previousPage(response.pedidoId);
      }, (error) => {
        this.spinnerService.hide();
        this.notificationService.error(error.message);
        this.previousPage(null);
      });
  }

  number(event): boolean {

    const charCode = (event.which) ? event.which : event.keyCode;

    if ((charCode == 45)) {

      this.formGeraPedido.controls['valorCarga'].setValue(null);
      this.notificationService.error('Não é permitido números negativos!');

    }
    return true;

  }

  limparForm() {

    this.formGeraPedido = this.formBuilder.group({
      valorCarga: [null],
    });

  }


  previousPage(pedidoId) {
    if (pedidoId != null) {
      this.dialogService.open(ModalPedidoGeradoComponent, {
        context: {
          pedidoId: pedidoId,

        },
      })
    }

    this.location.back();
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }


    buscarCentrosCusto() {
    let params = new HttpParams(); 
    params = params.append('status', 'ATIVO');
      
    this.spinnerService.show();

    this.centroCustoservice.buscaCentrosCusto(params,
      (response) => {
        this.spinnerService.hide();
        this.listCentroCusto = response.content;
      },
      (error) => {
        this.spinnerService.hide();
        this.notificationService.error(error.message);
      }
    );
  }
}
